<template>
  <div id="page-recu">
    <div id="recu-print"  ref="recu" class="recu-card">
      <!-- En-tête -->
      <div class="recu-header d-flex align-items-center mb-4 p-3 rounded-top">
        <img
          v-if="systeme?.logoUrl"
          :src="systeme.logoUrl"
          alt="Logo Clinique"
          class="logo"
        />
        <div class="flex-grow-1 text-center">
          <h2 class="fw-bold mb-1 text-white">{{ systeme?.nom ?? 'CLINIQUE' }}</h2>
          <small class="text-light d-block">
            {{ systeme?.adresse ?? 'Rue 123, Bamako' }} • {{ systeme?.telephone ?? '+223 77 29 88 24' }}
          </small>
        </div>
      </div>

      <!-- Titre et Référence -->
      <div class="d-flex justify-content-between align-items-center mb-4 px-3">
        <h4 class="text-primary fw-bold mb-0">Reçu de Consultation</h4>
        <small class="text-muted">Réf : {{ reference }}</small>
      </div>

      <!-- Infos patient et consultation -->
      <div class="row g-4 mb-3 px-3">
        <div class="col-md-6 info-card">
          <h5 class="card-title">Patient</h5>
          <p class="mb-1"><strong>N° consultation :</strong> {{ consultation?.numConsultation }}</p>
          <p class="mb-1"><strong>Nom :</strong> {{ consultation.patient?.nom }} {{ consultation.patient?.prenom }}</p>
          <p class="mb-1"><strong>Téléphone :</strong> {{ consultation.patient?.telephone }}</p>
          <p class="mb-0"><strong>Date :</strong> {{ formatDate(consultation?.createdAt) }}</p>
        </div>
        <div class="col-md-6 info-card">
          <h5 class="card-title">Consultation</h5>
          <p class="mb-1"><strong>Type :</strong> {{ consultation.type?.nom }}</p>
          <p class="mb-1"><strong>Assurance :</strong> {{ consultation.assurancePaiement }}</p>
          <p class="mb-0"><strong>Montant :</strong> {{ consultation.type?.prix }} FCFA</p>
        </div>
      </div>

      <!-- Statut paiement et Agent -->
      <div class="d-flex justify-content-between align-items-center mb-4 px-3">
        <span class="badge" :class="consultation.estPaye === 'Payé' ? 'badge-success' : 'badge-danger'">
          {{ consultation.estPaye }}
        </span>
        <span><strong>Agent :</strong> <span class="text-muted">{{ consultation.createdBy?.nom }} {{ consultation.createdBy?.prenom }}</span></span>
      </div>

      <hr class="divider" />

      <!-- QR Code -->
      <div class="text-center my-4">
        <qrcode-vue :value="consultation.patient?.numeroDossier.toString()" :size="140" />
        <p class="text-muted mt-2">ID Consultation : {{ consultation.id }}</p>
      </div>

      <!-- Boutons (masqués à l'impression) -->
      <div class="text-end mt-4 d-print-none px-3">
        <button class="btn btn-outline-primary me-2" @click="imprimer">
          <i class="bi bi-printer me-1"></i> Imprimer
        </button>
        <button class="btn btn-outline-success" @click="telechargerPDF">
          <i class="bi bi-download me-1"></i> Télécharger
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import dayjs from 'dayjs';
import QRCodeVue from 'qrcode.vue';
import html2pdf from 'html2pdf.js';

export default {
  components: { 'qrcode-vue': QRCodeVue },
  data() {
    return {
      consultation: {},
      reference: '',
      systeme: null,
    };
  },
  created() {
    this.getConsultation();
    this.getConfigurationSysteme();
    this.getConsultation();
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('DD-MM-YYYY HH:mm');
    },
    async getConsultation() {
      try {
        const { id } = this.$route.params;
        const res = await api.getItem('consultations', id);
        this.consultation = res.data;
        this.reference = `CON-${dayjs().format('DD')}-${id.toString().padStart(5, '0')}`;
      } catch (e) {
        console.error('Erreur chargement consultation', e);
      }
    },
    async getConfigurationSysteme() {
      try {
        const res = await api.getItems('configurations');
        this.systeme = res.data.data[0];
        const baseUrl = process.env.VUE_APP_API_BASE_URL || '';
        if (this.systeme.logo) this.systeme.logoUrl = baseUrl + this.systeme.logo;
      } catch (e) {
        console.error('Erreur chargement configuration système', e);
      }
    },
    /*imprimer() {
      const patientNom = this.consultation?.patient?.nom || 'Inconnu';
      const numConsultation = this.consultation?.numConsultation || 'NC';
      const date = dayjs(this.consultation?.createdAt).format('YYYYMMDD_HHmm');
      document.title = `Recu_${patientNom}_${numConsultation}_${date}`;
      window.print();
    },*/
  imprimer() {
  const config = this.systeme || {};
  const consultation = this.consultation || {};
  const patient = consultation.patient || {};
  const medecin = consultation.createdBy || {};
  const dateConsultation = this.formatDate(consultation.createdAt);
  const reference = this.reference;
  let titreDocument = "DOCUMENT DE CONSULTATION";

if (consultation.statut === "En attente") {
  titreDocument = "BON DE CONSULTATION";
} else if (consultation.statut === "Terminée" && consultation.estPaye === "Non payé") {
  titreDocument = "FACTURE DE CONSULTATION";
} else if (consultation.statut === "Terminée" && consultation.estPaye === "Payé") {
  titreDocument = "REÇU DE CONSULTATION";
}

  const baseURL = process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8000";
  const logoUrl = config.logo
    ? (config.logo.startsWith("http") ? config.logo : `${baseURL}${config.logo}`)
    : "";

  const printWindow = window.open("", "_blank");

  const htmlContent = `
  <html>
    <head>
      <title>Reçu de Consultation</title>
      <style>
        @page {
          size: A4;
          margin: 2cm;
        }

        body {
          font-family: "Times New Roman", serif;
          color: #000;
          font-size: 14px;
          line-height: 1.6;
          margin: 0;
          padding: 0;
        }

        header {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          height: 120px;
          display: flex;
          justify-content: space-between;
          border-bottom: 2px solid #0056b3;
          padding: 10px 2cm;
        }

        footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          height: 80px;
          border-top: 2px solid #0056b3;
          padding: 10px 2cm;
          font-size: 13px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .content {
          margin-top: 150px;
          margin-bottom: 100px;
          padding: 0 1cm;
        }

        header img {
          width: 80px;
          height: 80px;
          object-fit: contain;
        }

        .info { flex: 1; margin-left: 10px; }
        .info h2 { margin: 0; color: #0056b3; font-size: 20px; }
        .info p { margin: 2px 0; font-size: 13px; }

        h3 {
          text-align: center;
          color: #0056b3;
          text-decoration: underline;
          margin-bottom: 20px;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
        }

        th, td {
          border: 1px solid #0056b3;
          padding: 14px;
          font-size: 13px;
        }

        th {
          background-color: #e6f0ff;
          text-align: center;
        }

        .signature {
          text-align: right;
          margin-top: 40px;
        }
      </style>
    </head>

    <body>

      <header>
        <div style="display:flex; align-items:center;">
          ${logoUrl ? `<img src="${logoUrl}" alt="Logo Clinique">` : ""}
          <div class="info">
            <h2>${config.nom || "Clinique Médicale"}</h2>
            <p>${config.adresse || ""}</p>
            <p>Tél : ${config.telephone || ""}</p>
            ${config.email ? `<p>Email : ${config.email}</p>` : ""}
          </div>
        </div>
        <div style="text-align:right;">
          <p><strong>N° :</strong> ${reference}</p>
          <p><strong>Date :</strong> ${dateConsultation}</p>
        </div>
      </header>

      <div class="content">

        <h3>${titreDocument}</h3>

        <table style="width:100%; border-collapse:collapse; margin-bottom:20px;">
  <tr>
    <td style="padding:6px;">
      <strong>Nom du patient :</strong>
      ${patient.nom || ""} ${patient.prenom || ""}
    </td>
    <td style="padding:6px;">
      <strong>N° Dossier :</strong>
      ${patient.numeroDossier || "—"}
    </td>
  </tr>
  <tr>
    <td style="padding:6px;">
      <strong>N° Consultation :</strong>
      ${consultation.numConsultation || "—"}
    </td>
    <td style="padding:6px;">
      <strong>Date :</strong>
      ${dateConsultation}
    </td>
  </tr>
  <tr>
    <td style="padding:6px;">
      <strong>Statut :</strong>
      ${consultation.statut || "—"}
    </td>
    <td></td>
  </tr>
</table>


        <table>
          <tr>
            <th>Type de consultation</th>
            <th>Assurance</th>
            <th>Montant</th>
            <th>Statut</th>
          </tr>
          <tr>
            <td>${consultation.type?.nom || "—"}</td>
            <td>${consultation.assurancePaiement || "Aucune"}</td>
            <td>${consultation.type?.prix || 0} FCFA</td>
            <td>${consultation.estPaye || "—"}</td>
          </tr>
        </table>

        <div class="signature">
          <p><strong>L’Agent</strong></p>
          <p>${medecin.nom || ""} ${medecin.prenom || ""}</p>
          <br><br>
          <p>Signature & cachet</p>
        </div>

      </div>

      <footer>
    <p>${config.nom || ""} - ${config.adresse || ""}</p>
    <p>© ${new Date().getFullYear()} Tous droits réservés</p>
  </footer>

    </body>
  </html>
  `;

  printWindow.document.write(htmlContent);
  printWindow.document.close();

  printWindow.onload = function () {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
}

,
 telechargerPDF() {
  const element = this.$refs.recu;
  const images = element.querySelectorAll('img');
  const promises = Array.from(images).map(img => {
    if (!img.complete) {
      return new Promise(resolve => {
        img.onload = img.onerror = resolve;
      });
    }
    return Promise.resolve();
  });

  Promise.all(promises).then(() => {
    html2pdf().from(element).set({
      margin: 0,
      filename: this.reference + '.pdf',
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { orientation: 'portrait', unit: 'px', format: [element.offsetWidth, element.offsetHeight] }
    }).save();
  });
}

  }
};
</script>

<style scoped>
.recu-card {
  background: #fff;
  width: 100%;
  min-height: 100vh;
  padding: 30px;
  box-sizing: border-box;
  font-family: 'Segoe UI', sans-serif;
}

/* En-tête */
.recu-header {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  color: #fff;
}
.logo {
  height: 70px;
  width: 70px;
  object-fit: cover;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

/* Infos patient / consultation */
.info-card {
  background: #f9f9f9;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);
  border-left: 5px solid #0d6efd;
}
.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #0d6efd;
  margin-bottom: 10px;
}

/* Badge statut */
.badge {
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 25px;
}
.badge-success { background-color: #28a745; color: #fff; }
.badge-danger { background-color: #dc3545; color: #fff; }

/* Séparateur */
.divider { border: 0; border-top: 1px dashed #ccc; }
</style>

<style>
@media print {
  html, body {
    height: 100%;
    margin: 0;
    padding: 0;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  body * {
    visibility: hidden !important;
  }

  #recu-print, #recu-print * {
    visibility: visible !important;
  }

  #recu-print {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 30px !important;
    box-shadow: none !important;
    transform: none !important;
  }
}
</style>
